var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOriginIconAndText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 104.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#231f20;}.cls-3{fill:#08212a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 40.19,
    y1: 0.07,
    x2: 35.05,
    y2: 62.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#df1f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#d91f26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#cb2028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#c32029"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#c1212a"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,83.29c0-1.12,.2-2.11,.59-2.97,.39-.86,.91-1.58,1.57-2.15,.63-.55,1.34-.96,2.13-1.25,.8-.29,1.6-.43,2.41-.43s1.61,.14,2.41,.43c.8,.29,1.52,.7,2.17,1.25,.63,.57,1.13,1.29,1.53,2.15s.59,1.85,.59,2.97v14.72c0,1.17-.2,2.18-.59,3.01-.39,.84-.9,1.53-1.53,2.07-.65,.57-1.38,1-2.17,1.29-.8,.29-1.6,.43-2.41,.43s-1.61-.14-2.41-.43c-.8-.29-1.51-.72-2.13-1.29-.65-.55-1.17-1.24-1.57-2.07-.39-.83-.59-1.84-.59-3.01v-14.72Zm3.99,14.72c0,.97,.27,1.68,.8,2.13,.53,.46,1.17,.68,1.9,.68s1.36-.23,1.9-.68c.53-.46,.8-1.17,.8-2.13v-14.72c0-.97-.27-1.68-.8-2.13-.53-.46-1.17-.68-1.9-.68s-1.36,.23-1.9,.68c-.53,.46-.8,1.17-.8,2.13v14.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.91,104.58v-27.87h6.42c4.7,0,7.04,2.73,7.04,8.18,0,1.64-.25,3.04-.76,4.19-.51,1.15-1.4,2.07-2.68,2.78l4.31,12.72h-4.23l-3.72-11.9h-2.39v11.9h-3.99Zm3.99-24.11v8.69h2.27c.7,0,1.27-.1,1.68-.29,.42-.2,.74-.48,.98-.84,.21-.36,.35-.82,.43-1.35,.08-.53,.12-1.15,.12-1.86s-.04-1.32-.12-1.86c-.08-.53-.23-1-.47-1.39-.5-.73-1.44-1.1-2.82-1.1h-2.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.7,104.58v-27.87h3.99v27.87h-3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.33,83.29c0-1.12,.2-2.11,.59-2.97,.39-.86,.91-1.58,1.57-2.15,.63-.55,1.34-.96,2.13-1.25,.8-.29,1.6-.43,2.41-.43s1.61,.14,2.41,.43c.8,.29,1.52,.7,2.17,1.25,.63,.57,1.13,1.29,1.53,2.15s.59,1.85,.59,2.97v1.41h-3.99v-1.41c0-.97-.27-1.68-.8-2.13-.53-.46-1.17-.68-1.9-.68s-1.36,.23-1.9,.68c-.53,.46-.8,1.17-.8,2.13v14.72c0,.97,.27,1.68,.8,2.13,.53,.46,1.17,.68,1.9,.68s1.36-.23,1.9-.68c.53-.46,.8-1.17,.8-2.13v-5.24h-3.17v-3.52h7.16v8.77c0,1.17-.2,2.18-.59,3.01-.39,.84-.9,1.53-1.53,2.07-.65,.57-1.38,1-2.17,1.29-.8,.29-1.6,.43-2.41,.43s-1.61-.14-2.41-.43c-.8-.29-1.51-.72-2.13-1.29-.65-.55-1.17-1.24-1.57-2.07-.39-.83-.59-1.84-.59-3.01v-14.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M58.36,104.58v-27.87h3.99v27.87h-3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.07,104.58v-27.87h3.84l6.03,16.79h.08v-16.79h3.99v27.87h-3.76l-6.11-16.75h-.08v16.75h-3.99Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M49.92,38.62s11.43-8.84,6.42-24.46C51.47-1.04,33.1-4.44,22.81,7.79c0,0,17.19-8.84,27.58,9.87,0,0,5.01,10.28-.47,20.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.56,0c-11.05,0-20,8.95-20,20,0,9.77,14.16,34.98,18.74,42,.56,.85,1.81,.83,2.33-.05,4.16-6.98,18.92-32.46,18.92-41.95C58.56,8.95,49.61,0,38.56,0Zm2.13,33.67c-8.76,0-15.87-7.1-15.87-15.87S31.92,1.94,40.69,1.94s15.87,7.1,15.87,15.87-7.1,15.87-15.87,15.87Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOriginIconAndText);
export default __webpack_public_path__ + "static/media/origin-icon-and-text.61cae112419635bd3206fc613894b599.svg";
export { ForwardRef as ReactComponent };